import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  ehrType: 'epic',
  urls: {
    api: 'https://epic.staging.afasatjts.com/api',
    standaloneApi: 'https://staging.afasatjts.com/api',
  },
  fhirClientId: 'afa733ae-feaf-4777-b0da-afc9ba9c3a59',
  fhirRedirectUri: undefined,
  gtmId: 'GTM-M2HM4BPR',
  gtmAuth: `5P1R6S7HOrCpcaKHvoJSyg`,
  gtmPreview: `env-6`,
  externalLinks: {
    contactUs: 'https://jtsi.net/afas-contact-us',
    termsAndConditions: 'https://jtsi.net/terms-conditions',
    privacyPolicy: 'https://jtsi.net/afas-privacy-policy',
    supportEmail: 'afashelpdesk@jtsi.net',
    supportPhone: '703-914-3495',
  },
  Auth: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_VzqILEWIM',
    userPoolWebClientId: '4em71nfdsecb5s5f5he0n20ooh',
    mandatorySignIn: true,
    authenticationFlowType: 'USER_PASSWORD_AUTH',
    oauth: {
      domain: 'auth.staging.afasatjts.com',
      scope: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
      redirectSignIn: ['https://staging.afasatjts.com/contacts'],
      redirectSignOut: ['https://staging.afasatjts.com/contacts'],
      responseType: 'code',
    },
  },
};
